export const CountryCodeConstants = {
    GET_COUNTRY_CODE: 'GET_COUNTRY_CODE',

    GET_COUNTRY_CODE_REQUEST: 'GET_COUNTRY_CODE_REQUEST',
    GET_COUNTRY_CODE_SUCCESS: 'GET_COUNTRY_CODE_SUCCESS',
    GET_COUNTRY_CODE_FAILURE: 'GET_COUNTRY_CODE_FAILURE'
};
